<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="sm:mt-9 mt-8">
    <div class="sm:text-8 sm:leading-10 text-7 leading-9">
      {{ t('Global.JoinAPlatformThatCares') }}
    </div>
    <div class="grid mt-8 sm:grid-cols-2 sm:gap-9 sm:mt-9 grid-cols-1 gap-8">
      <div class="text-center sm:text-left flex flex-col items-center sm:items-start">
        <img v-if="isDark" src="@/assets/login/join1.webp" class="w-14 h-14" alt="dfans" />
        <img v-else src="@/assets/login/join1-b.webp" class="w-14 h-14" alt="dfans" />
        <div class="text-xl mt-5">
          {{ t('Login.JoinTitle1') }}
        </div>
        <div class="w-75 text-brandB mt-2 text-base">
          {{ t('Login.JoinDesc1') }}
        </div>
      </div>
      <div class="text-center sm:text-left flex flex-col items-center sm:items-start">
        <img v-if="isDark" src="@/assets/login/join2.webp" class="w-14 h-14" alt="dfans" />
        <img v-else src="@/assets/login/join2-b.webp" class="w-14 h-14" alt="dfans" />
        <div class="text-xl mt-5">
          {{ t('Login.JoinTitle2') }}
        </div>
        <div class="w-75 text-brandB mt-2 text-base">
          {{ t('Login.JoinDesc2') }}
        </div>
      </div>
      <div class="text-center sm:text-left flex flex-col items-center sm:items-start">
        <img v-if="isDark" src="@/assets/login/join3.webp" class="w-14 h-14" alt="dfans" />
        <img v-else src="@/assets/login/join3-b.webp" class="w-14 h-14" alt="dfans" />
        <div class="text-xl mt-5">
          {{ t('Login.JoinTitle3') }}
        </div>
        <div class="w-75 text-brandB mt-2 text-base">
          {{ t('Login.JoinDesc3') }}
        </div>
      </div>
      <div class="text-center sm:text-left flex flex-col items-center sm:items-start">
        <img v-if="isDark" src="@/assets/login/join4.webp" class="w-14 h-14" alt="dfans" />
        <img v-else src="@/assets/login/join4-b.webp" class="w-14 h-14" alt="dfans" />
        <div class="text-xl mt-5">
          {{ t('Login.JoinTitle4') }}
        </div>
        <div class="w-75 text-brandB mt-2 text-base">
          {{ t('Login.JoinDesc4') }}
        </div>
      </div>
    </div>
  </div>
</template>
